const brandConfig = require(process.env.GATSBY_DN_BRAND_FILE).default;
export default brandConfig;
